export interface TableProps {
  title?: string;
  tableType?: string;
  data: any;
  columns: any;
  tableWidth?: string;
  defaultRows: number;
  rowsPerPage: Array<number>;
  isLoading: boolean;
  searchable?: boolean;
  handleAddButton?: () => void;
  sliderFilters?: Array<SliderFilter>;
  dropDownFilters?: any;
  multiDropDownFilters?: any;
  selectedRows?: any;
  handleDeleteSelected?: any;
  editable?: boolean;
  handleAddTeamMember?: any;
}

export interface SliderFilter {
  props?: any;
  id: number;
  title: string;
  min: number;
  max: number;
}

export enum TableTypes {
  Members = "Members",
  Teams = "Teams",
  Roles = "Roles",
  Companies = "Companies",
  Offices = "Offices",
  Rooms = "Rooms",
  Dashboards = "Dashboards",
}
